
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getStaDetail,
  getFeeInfo,
  getStaFeeDetails,
  getMapStaInfo
} from "@/api/api-operation-service";
import siteSteps from "./components/site-steps.vue";
import rateChangeRecord from "./components/rate-change-record.vue";
import tabsContent from "@/components/tabs-content/tabs-content.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-site-steps": siteSteps,
    "pi-tabs-content": tabsContent,
    "pi-rate-change-record": rateChangeRecord
  }
})
export default class PiSiteDetails extends Vue {
  private tabsList: objAny[] = [
    { value: "tab1", title: i18n.t("pileInfoDetail.tab1") },
    { value: "tab2", title: i18n.t("pileInfoDetail.tab2") },
    { value: "tab3", title: i18n.t("pileInfoDetail.tab3") }
  ];
  private tabsActive = "tab1";
  public tabChange(data: string): void {
    if (data == "tab2" && !this.isTabs2) {
      this.isTabs2 = true;
    } else if (data == "tab3" && !this.isTabs3) {
      this.isTabs3 = true;
    }
    this.tabsActive = data;
  }
  private staInfoData: objAny = {};
  private totalDev = 0;
  private isTabs2 = false;
  private isTabs3 = false;
  private staPkId = "";
  private modalPower: objAny = {};
  /**
   * 直流充电费率
   */
  oprDcFeeInfos: objAny[] = [];
  /**
   * 交流充电费率
   */
  oprAcFeeInfos: objAny[] = [];

  /**
   * 延时费费率
   */
  oprDelayFeeInfos: objAny[] = [];
  oprDelayFeeInfosAc: objAny[] = [];
  oprDelayFeeInfosDc: objAny[] = [];
  private delayFee: objAny = {}; // 延时费率
  private concurrentFee: objAny = {}; // 当前费率
  /**
   * 时段标记
   */
  slotFlag = [
    i18n.t("commonTableName.jian"),
    i18n.t("commonTableName.feng"),
    i18n.t("commonTableName.ping"),
    i18n.t("commonTableName.gu")
  ];
  /**
   * 延时费费率
   */
  oprDelayFeeInfos: objAny[] = [];
  private formInline: objAny = {
    type: "",
    city: "",
    userName: "",
    globalPageIndex: 1,
    globalPageSize: 20
  };
  private tableColumnsFee: objAny[] = [
    {
      title: i18n.t("pileInfoEle.time"),
      key: "time",
      minWidth: 130
    },
    {
      title: i18n.t("pileInfoEle.slotElecPrice"),
      key: "slotElecPrice",
      minWidth: 120
    },
    {
      title: i18n.t("pileInfoEle.slotServicePrice"),
      key: "slotServicePrice",
      minWidth: 140
    },
    {
      title: i18n.t("pileInfoDetail.price"),
      key: "price",
      minWidth: 120
    }
  ];
  private tableColumnsDelay: objAny[] = [
    {
      title: i18n.t("pileInfoEle.time"),
      key: "time",
      minWidth: 120
    },
    {
      title: i18n.t("pileInfoEle.slotDelayPrice"),
      key: "price",
      minWidth: 120
    }
  ];
  private tableList: objAny[] = [];
  private tableColumns: objAny[] = [
    {
      title: i18n.t("pileInfoEle.time"),
      key: "operCode",
      minWidth: 120
    },
    {
      title: i18n.t("pileInfoEle.slotElecPrice"),
      key: "pileType",
      minWidth: 120
    },
    {
      title: i18n.t("pileInfoEle.slotServicePrice"),
      key: "status",
      minWidth: 120
    }
  ];
  private tableListPile: objAny[] = [];
  private tableColumnsPile: objAny[] = [
    {
      title: i18n.t("commonTableName.serialNumber"),
      key: "serialNumber",
      minWidth: 120
    },
    {
      title: i18n.t("commonTableName.deviceType"),
      key: "deviceTypeDesc",
      minWidth: 120
    },
    {
      title: i18n.t("pileInfoDetail.manufacturerName"),
      key: "manufacturerName",
      minWidth: 120
    },
    {
      title: i18n.t("pileInfoDetail.ratedPower"),
      key: "ratedPower",
      minWidth: 120
    }
  ];
  private feeData: objAny = {};

  async getDetail(staPkId: string): Promise<void> {
    const ret = await getStaDetail({ staPkId });
    if (ret.status == this["$config"].apiStatus) {
      this.formInline = ret.data[0];
      this.tableListPile = ret.data[0].chargePileVos;
    }
  }

  async getFeeDetail(feePkId: string): Promise<void> {
    // const ret = await getFeeInfo({ feePkId });
    // if (ret.status == this["$config"].apiStatus) {
    //   const dData = ret.data;
    //   this.feeData = dData[0];
    //   /**
    //    * 交流电数据
    //    */
    //   const oprAcFeeInfos = dData[0].oprAcFeeInfos.sort(
    //     (a: objAny, b: objAny) => {
    //       return a.beginTime - b.beginTime;
    //     }
    //   );

    //   this.oprAcFeeInfos = this.cleanFeeData(oprAcFeeInfos);
    //   /**
    //    * 直流电数据
    //    */
    //   const oprDcFeeInfos = dData[0].oprDcFeeInfos.sort(
    //     (a: objAny, b: objAny) => {
    //       return a.beginTime - b.beginTime;
    //     }
    //   );
    //   this.oprDcFeeInfos = this.cleanFeeData(oprDcFeeInfos);
    //   /**
    //    * 延时费费率
    //    */
    //   const oprDelayFeeInfos = dData[0].oprDelayFeeInfos.sort(
    //     (a: objAny, b: objAny) => {
    //       return a.beginTime - b.beginTime;
    //     }
    //   );
    //   this.oprDelayFeeInfos = this.cleanDelayFeeData(oprDelayFeeInfos);
    // }
    const ret = await getStaFeeDetails({ staPkId: this.staPkId });
    if (ret.status == this["$config"].apiStatus) {
      const dData = ret.data[0] || {};

      this.concurrentFee = dData.concurrentFee || {};
      this.delayFee = dData.delayFee || {};
      if (dData.concurrentFee) {
        // 费率交流
        const oprAcFeeInfos = this.concurrentFee.oprAcFeeInfos.sort(
          (a: objAny, b: objAny) => {
            return a.beginTime - b.beginTime;
          }
        );

        this.oprAcFeeInfos = this.cleanFeeData(oprAcFeeInfos);
        // 费率直流
        const oprDcFeeInfos = this.concurrentFee.oprDcFeeInfos.sort(
          (a: objAny, b: objAny) => {
            return a.beginTime - b.beginTime;
          }
        );

        this.oprDcFeeInfos = this.cleanFeeData(oprDcFeeInfos);
      }
      if (dData.delayFee) {
        //延时费费率交流
        const oprDelayFeeInfosAc = this.delayFee.oprAcFeeInfos.sort(
          (a: objAny, b: objAny) => {
            return a.beginTime - b.beginTime;
          }
        );
        this.oprDelayFeeInfosAc = this.cleanDelayFeeData(oprDelayFeeInfosAc);
        // 延时费费率直流
        const oprDelayFeeInfosDc = this.delayFee.oprAcFeeInfos.sort(
          (a: objAny, b: objAny) => {
            return a.beginTime - b.beginTime;
          }
        );
        this.oprDelayFeeInfosDc = this.cleanDelayFeeData(oprDelayFeeInfosDc);
      }
    }
  }

  /**
   * 清洗费率详情数据
   * @param unit  单位
   * @param dData
   */
  cleanFeeData(dData: objAny[]): objAny[] {
    return dData.map((item: objAny) => {
      const beginTime = this.convertStringToTimes(item.beginTime);
      const endTime = this.convertStringToTimes(item.endTime);
      const time = `${beginTime} - ${endTime}`;
      const cItem: objAny = {
        time: time + " " + this.slotFlag[item.slotFlag - 1],
        flagText: this.slotFlag[item.slotFlag - 1],
        slotElecPrice: item.slotElecPrice,
        slotServicePrice: item.slotServicePrice,
        price: (item.slotElecPrice + item.slotServicePrice).toFixed(4)
      };
      return cItem;
    });
  }

  /**
   * 清洗延时费率详情数据
   * @param unit  单位
   * @param dData
   */
  cleanDelayFeeData(dData: objAny[]): objAny[] {
    return dData.map((item: objAny) => {
      const beginTime = this.convertStringToTimes(item.beginTime);
      const endTime = this.convertStringToTimes(item.endTime);
      const time = `${beginTime} - ${endTime}`;
      const cItem: objAny = {
        time: time,
        flagText: this.slotFlag[item.slotFlag],
        price: item.slotDelayPrice
          ? item.slotDelayPrice + i18n.t("pileInfoDetail.delayUnit")
          : "0" + i18n.t("pileInfoDetail.delayUnit")
      };
      return cItem;
    });
  }
  /**
   * 把例如12:30转换为1230
   * @param data 小时*100+分钟
   */
  convertTimesToString(data: string): number {
    const times = data.split(":");
    const str = Number(times[0]) * 100 + Number(times[1]);
    return str;
  }

  /**
   * 把例如1230转为12:30
   * @param data 08：00
   * @param processData
   */
  convertStringToTimes(data: string | number): string {
    const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
    const min = String(Number(data) % 100).padStart(2, "0");
    return `${hour}:${min}`;
  }

  async getStaInfo(): Promise<void> {
    const ret = await getMapStaInfo({ staPkId: this.staPkId });
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0];
      this.staInfoData = data;
      const acPileCount = data.acPileCount || 0;
      const dcPileCount = data.dcPileCount || 0;
      this.totalDev = acPileCount + dcPileCount;
    }
  }

  mounted(): void {
    const localData = this["$common"].get(this.$route.path);
    if (this.staPkId != localData.staPkId) {
      this.isTabs2 = false;
      this.isTabs3 = false;
      this.tabsActive = "tab1";
      this.staPkId = localData.staPkId;
      this.getDetail(localData.staPkId);
      this.getStaInfo();
      if (localData.feePkId) {
        this.getFeeDetail(localData.feePkId);
      } else {
        this.feeData = {};
        this.oprAcFeeInfos = [];
        this.oprDcFeeInfos = [];
        this.oprDelayFeeInfos = [];
      }
    }

    this.$nextTick(() => {
      this.modalPower = this.$refs["modalPower"] || {};
    });
  }
}
